// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'bell-off-solid';

export const Component = () => (
  <path d='M21.11 19.63H8.944L19.002 5.31c.288.623.48 1.293.575 2.012l1.006 7.088c.047.192.144.383.287.575l1.293 1.293c.288.288.432.623.432 1.006v.861c0 .432-.144.767-.432 1.054a1.408 1.408 0 0 1-1.054.431ZM17.133 2.82 5.354 19.63h-1.87c-.431 0-.766-.144-1.054-.432A1.408 1.408 0 0 1 2 18.145v-.862c0-.383.144-.719.431-1.006l1.293-1.293c.144-.191.24-.382.288-.575l1.005-7.136c.24-1.771 1.054-3.257 2.442-4.453C8.85 1.622 10.477 1 12.297 1c1.772 0 3.4.623 4.789 1.82h.048ZM8.897 20.635h6.8a3.687 3.687 0 0 1-1.149 2.107c-.622.574-1.389.862-2.25.862-.862 0-1.628-.288-2.251-.862a3.687 3.687 0 0 1-1.15-2.107ZM19.48 2.101c.144.144.192.239.192.383 0 .143-.048.24-.096.287L5.784 22.407a.435.435 0 0 1-.383.191c-.335 0-.48-.143-.48-.478 0-.144.049-.24.097-.288L18.763 2.196a.435.435 0 0 1 .383-.191c.048 0 .144.047.335.096Z' />
);

export const viewBox = '0 0 25 25';
